import { Deserializable } from './deserializable.model';
import { JsonObject } from './json-object.model';
import { LocalResourceHours } from './local-resource-hours.model';
import { PhoneNumber } from './phone-number.model';

export class LocalResourceLocation implements Deserializable<JsonObject, LocalResourceLocation> {
  constructor(
    public address1?: string,
    public address2?: string,
    public city?: string,
    public formattedHours?: LocalResourceHours,
    public phoneNumber?: PhoneNumber,
    public postal?: string,
    public state?: string,
    public distance?: number,
    public email?: string,
    public notes?: string,
    public fax?: string,
    public name?: string,
    public isAdministrative?: boolean
  ) {}

  deserialize(input: JsonObject): LocalResourceLocation {
    if (input == null) {
      return null;
    }

    this.address1 = input['address1'];
    this.address2 = input['address2'];
    this.city = input['city'];
    this.formattedHours = input['formattedHours'] || new LocalResourceHours().deserialize(input['hours']);
    this.phoneNumber =
      input['phoneNumber'] || (input['phone_number'] ? new PhoneNumber().deserialize(input['phone_number']) : null);
    this.postal = input['postal'];
    this.state = input['state'];
    this.distance = Math.round(input['distance']);
    this.email = input['email'];
    this.notes = input['notes'];
    this.fax = input['fax_number'];
    this.name = input['name'];
    this.isAdministrative = input['is_administrative'] || input['isAdministrative'];

    return this;
  }
}
